import {SyncstepId} from '../../constants';

/**
 * eFeide password export is best-effort: we cannot know the user has an eFeide
 * account (no anchors). Progress / resume must not wait on or fail on these rows.
 *
 * `syncstepid` is often 0/missing because Target is an NIN, not an anchor —
 * `targetsystem` is `eFeide:{CustomerKey}` and is the reliable signal.
 */
export function isSilentPasswordExport(row: {syncstepid?: number; targetsystem?: string}): boolean {
    if (row.syncstepid === SyncstepId.Export_eFeide) {
        return true;
    }
    const targetsystem = row.targetsystem ?? '';
    return targetsystem.toLowerCase().startsWith('efeide:');
}
